import * as StackTrace from 'stacktrace-js';

export class ClientErreur {
    message: string;
    stackTrace: StackTrace.StackFrame[];
}